import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { isStandaloneMode } from '@constants/app-modes';

import PublisherRoutes from 'src/routes/PublisherRoutes';
import BaseRequestComponent from 'src/BaseRequestComponent';
import Notifications from '@uikit/old/Notifications/Notifications';

import store from 'src/store';
import gtm from 'src/libs/gtm';

import './vendors/normalize.css';
import './vendors/integrations.scss';
import { initCrossDomainStorage } from '@utils/crossDomainStorage';
import { syncGlobalToLocalStorage } from '@utils/localStorageHandler';
import { logStartupBanner } from '@utils/logger';
import { initGlobalErrorLogging } from '@utils/globalErrorLogging';
import { captureAttribution } from '@helpers/attribution';

logStartupBanner();
initGlobalErrorLogging();
// Must run before any redirect/integration logic that rewrites the URL. See TRACK-001.
captureAttribution();

const queryClient = new QueryClient();

declare const GAPI_CLIENT_ID: string;
declare const GTM_ID: string;

initCrossDomainStorage()
  .then(() => syncGlobalToLocalStorage())
  .then(() => {
    console.log('Global to local storage synchronization completed on startup');
  })
  .catch((error) => {
    console.error('Failed to initialize cross-domain storage:', error);
  });

window.addEventListener('unload', () => {
  import('@utils/crossDomainStorage').then((module) => {
    module.cleanupCrossDomainStorage();
  });
});

const initializeCustomGTM = () => {
  if (isStandaloneMode() && GTM_ID?.length) {
    gtm.init(GTM_ID);
    console.log('GTM initialized');
  }
};

ReactDOM.render(
  <GoogleOAuthProvider clientId={GAPI_CLIENT_ID}>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Router>
          <BaseRequestComponent>
            <>
              <PublisherRoutes />
              <Notifications />
              {/* <VersionTag /> */}
            </>
          </BaseRequestComponent>
        </Router>
      </Provider>
    </QueryClientProvider>
  </GoogleOAuthProvider>,
  document.getElementById('root')
);

initializeCustomGTM();
